import on from 'dom-helpers/addEventListener';
import qsa from 'dom-helpers/querySelectorAll';
import toggleCls from 'dom-helpers/toggleClass';
import closest from 'dom-helpers/closest';

export default doc => {
  on(doc, 'click', e => {
    if (!e.target) return;

    var $data = closest(e.target, '[data-target]');
    if (!$data) return;

    let $target = $data.dataset.target;
    toggleCls($data, 'is-active');

    qsa(doc, $target).forEach($el => toggleCls($el, 'is-active'));
  });
};
